<template>
  <div>
    <v-dialog v-model="sessionDialogEnabled" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">Your Session is Expiring</v-card-title>
        <v-card-text class="pt-5 pb-10">
          <v-row dense>
            <v-col cols="3" class="text-center">
              <v-icon x-large color="secondary"
                >fas fa-exclamation-triangle</v-icon
              >
            </v-col>
            <v-col cols="9" class="black--text mt-n2 pr-10">
              You will be logged out in
              <span class="title">{{
                Math.floor(timeToExpiration / 1000)
              }}</span>
              seconds. <br />If you'd like to continue working, click the
              <b>Continue Session</b> button.
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pr-5 pb-5">
          <v-spacer></v-spacer>
          <v-btn @click="logout" outlined>Log Out</v-btn>
          <v-btn color="primary" @click="extendSession">Continue Session</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  computed: {
    ...mapState({
      sessionDialogEnabled: state => state.session.showSessionDialog,
      toastRemainingTrigger: state => state.session.toastRemainingTrigger,
      toastInterval: state => state.session.toastInterval,
      timeToExpiration: state => state.session.timeToExpiration,
      expirationCheckInterval: state => state.session.expirationCheckInterval,
    }),
  },
  data() {
    return {
      countdown: 0,
      intervalId: null,
    };
  },
  methods: {
    handleTime() {
      this.handleTimeLogout();
      this.handleTimeToast();
    },
    handleTimeLogout() {
      if (this.timeToExpiration <= 0) {
        this.logout();
      }
    },
    handleTimeToast() {
      const {
        expirationCheckInterval,
        timeToExpiration,
        toastInterval,
        toastRemainingTrigger,
      } = this;

      if (timeToExpiration > toastRemainingTrigger + 1000) return;
      if (timeToExpiration < toastInterval) return;

      if (timeToExpiration % toastInterval < expirationCheckInterval) {
        this.$notifyWarn({
          message: `Session expires in ${Math.floor(
            timeToExpiration / 60000
          )} minute(s).`,
        });
      }
    },
    init() {
      this.intervalId = setInterval(this.updateEta, 1000);
    },
    logout() {
      this.sessionLogout();
      location.href = "/";
    },
    ...mapActions({
      extendSession: "session/extendSession",
      sessionLogout: "session/logout",
    }),
  },
  name: "sessionDialog",
  watch: {
    showSessionDialog(flag) {
      clearInterval(this.intervalId);
      if (flag) {
        this.init();
      }
    },
    timeToExpiration() {
      this.handleTime();
    },
  },
};
</script>
